<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="540"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Row>
                    <Col span="24">
                        <FormItem label="登录账号：" prop="partner_name">
                            <Input v-model="Forms.partner_name" placeholder="建议手机号" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="登录密码：" prop="password">
                            <Input v-model="Forms.password" :placeholder="!Forms.admin_id?'默认密码:123456':'填写则修改密码'" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="企业名称：" prop="company">
                            <Input v-model="Forms.company" placeholder="必填" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="姓名：" prop="real_name">
                            <Input v-model="Forms.real_name" placeholder="必填" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="手机号码：" prop="mobile">
                            <Input v-model="Forms.mobile" placeholder="必填" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="微信号：" prop="wechat">
                            <Input v-model="Forms.wechat" placeholder="非必填" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="电子邮箱：" prop="email">
                            <Input v-model="Forms.email" placeholder="非必填" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="收款账号：" prop="account">
                            <Input v-model="Forms.account" placeholder="非必填" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="企业微信ID：" prop="wx_id">
                            <Input v-model="Forms.wx_id" placeholder="非必填" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="账户状态：">
                            <RadioGroup v-model="Forms.status" type="button">
                                <Radio :label="1">审核</Radio>
                                <Radio :label="2">禁用</Radio>
                                <Radio :label="3">开启</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button style="margin-right: 8px" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">保存</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {savePartner, getPartnerDetail} from "@/apis/partner";

export default {
    name: 'Create',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '新增合作商',
            isBox : false,
            groupList : [],
            Forms : {
                partner_id:'',
                partner_name: '',
                company: '',
                group_id: 0,
                password: '',
                real_name: '',
                mobile: '',
                wechat: '',
                account: '',
                email: '',
                wx_id: '',
                status: 3
            },
            Rules : {
                partner_name: [
                    { required: true, message: '请输入登录账号', trigger: 'blur' },
                    { type: 'string', min: 5, message: '用户名不能少于6个字符', trigger: 'blur' }
                ],
                company: [
                    { required: true, message: '请输入企业名称', trigger: 'blur' },
                ],
                password: [
                    { type: 'string', min: 6, message: '密码不能少于6个字符', trigger: 'blur' }
                ],
                real_name: [
                    { required: true, message: '请填写姓名', trigger: 'blur' },
                ],
                mobile: [
                    { required: true, message: '请填写手机号码', trigger: 'blur' },
                ]
            }
        }
    },
    methods: {
        /**
         功能：获取详情
         time: 2025-53-02 10:53:04
         **/
        GetDetail(partner_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getPartnerDetail(partner_id).then(e => {
                let data = e.data;
                for (let v of Object.keys(that.Forms)) {
                    if(v === 'status'){
                        that.Forms[v] = parseInt(data[v]);
                    }else{
                        that.Forms[v] = data[v];
                    }
                }
            })
        },
        /**
         功能：添加
         time: 2025-52-02 10:52:34
         **/
        add(){
            this.isBox = true;
        },
        /**
         功能：编辑
         time: 2025-52-02 10:52:42
         **/
        edit(partner_id){
            this.isBox = true;
            this.title = '编辑合作商';
            if(partner_id) this.GetDetail(partner_id);
        },
        /**
         功能：
         time: 2025-55-02 10:55:40
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    savePartner(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2025-55-02 10:55:45
         **/
        FormReset(){
            this.isBox = false;
            this.title = '新增合作商';
            this.$refs['Forms'].resetFields();
            this.Forms.partner_id = '';
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
.forms {
    .ivu-form-item {
        //margin-bottom: 0 !important;
    }
}
.spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.spin-text {
    font-size: 12px;
    padding-top: 10px;
}
</style>
